import React, { useCallback, useContext, useMemo, useState } from "react";

export type PasskeyRecommendationContextValue = {
    pendingPasskeyRecommendation: boolean;
    requestPasskeyRecommendation: () => void;
    clearPasskeyRecommendation: () => void;
};

const defaultPasskeyRecommendationContext: PasskeyRecommendationContextValue =
    {
        pendingPasskeyRecommendation: false,
        requestPasskeyRecommendation: () => {},
        clearPasskeyRecommendation: () => {},
    };

const PasskeyRecommendationContext = React.createContext(
    defaultPasskeyRecommendationContext,
);

export type PasskeyRecommendationProviderProps = React.PropsWithChildren;

export function PasskeyRecommendationProvider({
    children,
}: PasskeyRecommendationProviderProps) {
    const [pendingPasskeyRecommendation, setPendingPasskeyRecommendation] =
        useState(false);

    const requestPasskeyRecommendation = useCallback(() => {
        setPendingPasskeyRecommendation(true);
    }, []);

    const clearPasskeyRecommendation = useCallback(() => {
        setPendingPasskeyRecommendation(false);
    }, []);

    const value = useMemo(
        (): PasskeyRecommendationContextValue => ({
            pendingPasskeyRecommendation,
            requestPasskeyRecommendation,
            clearPasskeyRecommendation,
        }),
        [
            pendingPasskeyRecommendation,
            requestPasskeyRecommendation,
            clearPasskeyRecommendation,
        ],
    );

    return (
        <PasskeyRecommendationContext.Provider value={value}>
            {children}
        </PasskeyRecommendationContext.Provider>
    );
}

export function usePasskeyRecommendation(): PasskeyRecommendationContextValue {
    return useContext(PasskeyRecommendationContext);
}
